import { v4 as uuidv4 } from 'uuid';

export interface TripExpense {
  id?: number | null;
  title: 'Hotel' | 'Air Travel' | 'Ground Travel' | 'Other';
  cost: number;
  description?: string;
  /** may be a legacy field? */
  isReimbursable?: boolean;
  isQuoted: boolean;
  /** only exists client side to make the service code more sane */
  receipt: File | string;
  uuid?: string; // only exists for frontend reasons, as a key
}

export function createNewExpense(): TripExpense {
  return {
    id: null,
    title: 'Hotel',
    cost: 0,
    description: '',
    isReimbursable: true,
    isQuoted: false,
    receipt: '',
    uuid: uuidv4(),
  };
}
